import * as React from "react"
import LazyImage from "../general/lazyImage"
import Translate from '../general/translate'

const Clipssection = () => {

  return (
    <div className="bg-[#FAFAFA] pb-10 px-6 md:px-10">
      <div className="relative bg-[#643ADA] sm:bg-opacity-5 bg-opacity-0 p-0 sm:p-6 md:px-14 max-w-7xl m-auto rounded-3xl">
        <div className="relative flex flex-col lg:flex-row items-center justify-between lg:space-x-16 rounded-3xl">
          <div className="lg:w-1/2 relative">
            <LazyImage
              src="/features/repurpose-podcast-content/videomodal.webp"
              className="rounded-2xl shadow-lg "
              alt="Clip Screenshot"
            />
          </div>
          <div className="lg:w-1/2 mt-8 sm:mt-14 lg:mt-0 text-white">
            <h2 className="text-[#643ADA] text-lg md:text-xl font-extrabold">
              <Translate id="clipsAndAudiograms.title" foldername="home" filename="home-clipssection" />
            </h2>
            <h2 className="text-[#27004F] text-3xl leading-tight md:text-5xl font-extrabold mt-2 mb-4">
              <Translate id="clipsAndAudiograms.subtitle" foldername="home" filename="home-clipssection" />
            </h2>
            <LazyImage src="/home/social-media-icons.png" className="rounded-lg p-2 mb-4 w-40" alt="social media icons"/>
            <p className="text-xl text-[#27004F] opacity-70 mb-0 sm:mb-6 ">
              <Translate id="clipsAndAudiograms.description" foldername="home" filename="home-clipssection" />
            </p>
            <a href="/squeeze" className="transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 bg-[#FFCA1D] text-[#483187] font-bold text-xl px-8 py-4 rounded-[8px] shadow hover:shadow-lg inline-block hidden md:inline-block">
              <Translate id="clipsAndAudiograms.createClips" foldername="home" filename="home-clipssection" />
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl m-auto grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8">
        <div className="bg-[#643ADA] bg-opacity-5 p-6 md:px-14 rounded-3xl">
          <h3 className="text-[#27004F] text-2xl md:text-3xl font-extrabold mb-4">
            <Translate id="textEditor.title" foldername="home" filename="home-clipssection" />
          </h3>
          <p className="text-[#27004F] text-md opacity-60 mb-4">
            <Translate id="textEditor.description" foldername="home" filename="home-clipssection" />
          </p>
          <LazyImage
            src="/home/text-based-editor.webp" 
            className="rounded-lg m-auto p-0 sm:p-8"
            alt="Text based editor"
          />
        </div>
        <div className="bg-[#643ADA] bg-opacity-5 p-6 md:px-14 rounded-3xl">
          <h3 className="text-[#27004F] text-2xl md:text-3xl font-extrabold mb-4">
            <Translate id="oneClickShorts.title" foldername="home" filename="home-clipssection" />
          </h3>
          <p className="text-[#27004F] text-md opacity-60 mb-4">
            <Translate id="oneClickShorts.description" foldername="home" filename="home-clipssection" />
          </p>
          <LazyImage
            src="/home/ai-edit.webp" 
            className="rounded-lg m-auto p-0 sm:p-8"
            alt="One click shorts"
          />
        </div>
      </div>
      <a href="/squeeze" className="transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 bg-[#FFCA1D] text-[#483187] font-bold text-xl px-8 py-4 rounded-[8px] shadow hover:shadow-lg inline-block mt-8 md:hidden">
        <Translate id="clipsAndAudiograms.createClips" foldername="home" filename="home-clipssection" />
      </a>
    </div>
  )
}

export default Clipssection